unit share.messagebox;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, WEBLib.Buttons;

type
  TfrmMessage = class(TForm)
    lTitle: TLabel;
    sbMain: TScrollBox;
    btnFirst: TSpeedButton;
    btnSecond: TSpeedButton;
    lMessage: TLabel;
    procedure btnSecondClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmMessage: TfrmMessage;

implementation

{$R *.dfm}

procedure TfrmMessage.btnSecondClick(Sender: TObject);
begin
  Close;
end;

procedure TfrmMessage.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lTitle := TLabel.Create(Self);
  sbMain := TScrollBox.Create(Self);
  lMessage := TLabel.Create(Self);
  btnFirst := TSpeedButton.Create(Self);
  btnSecond := TSpeedButton.Create(Self);

  lTitle.BeforeLoadDFMValues;
  sbMain.BeforeLoadDFMValues;
  lMessage.BeforeLoadDFMValues;
  btnFirst.BeforeLoadDFMValues;
  btnSecond.BeforeLoadDFMValues;
  try
    Name := 'frmMessage';
    Width := 468;
    Height := 201;
    Color := clSilver;
    lTitle.SetParentComponent(Self);
    lTitle.Name := 'lTitle';
    lTitle.Left := 0;
    lTitle.Top := 0;
    lTitle.Width := 468;
    lTitle.Height := 25;
    lTitle.Align := alTop;
    lTitle.AutoSize := False;
    lTitle.Caption := 'dlgMessage';
    lTitle.Color := clSilver;
    lTitle.Font.Charset := DEFAULT_CHARSET;
    lTitle.Font.Color := clWindowText;
    lTitle.Font.Height := -15;
    lTitle.Font.Name := 'Segoe UI';
    lTitle.Font.Style := [fsBold];
    lTitle.HeightPercent := 100.000000000000000000;
    lTitle.ParentFont := False;
    lTitle.WidthPercent := 100.000000000000000000;
    sbMain.SetParentComponent(Self);
    sbMain.Name := 'sbMain';
    sbMain.Left := 0;
    sbMain.Top := 25;
    sbMain.Width := 468;
    sbMain.Height := 176;
    sbMain.Align := alClient;
    sbMain.BorderStyle := bsSingle;
    sbMain.ChildOrder := 1;
    sbMain.Color := clSilver;
    lMessage.SetParentComponent(sbMain);
    lMessage.Name := 'lMessage';
    lMessage.Left := 32;
    lMessage.Top := 16;
    lMessage.Width := 401;
    lMessage.Height := 93;
    lMessage.Alignment := taCenter;
    lMessage.AutoSize := False;
    lMessage.Caption := 'Message';
    lMessage.Font.Charset := DEFAULT_CHARSET;
    lMessage.Font.Color := clWindowText;
    lMessage.Font.Height := -12;
    lMessage.Font.Name := 'Segoe UI';
    lMessage.Font.Style := [fsBold];
    lMessage.HeightPercent := 100.000000000000000000;
    lMessage.Layout := tlCenter;
    lMessage.ParentFont := False;
    lMessage.WidthPercent := 100.000000000000000000;
    btnFirst.SetParentComponent(sbMain);
    btnFirst.Name := 'btnFirst';
    btnFirst.Left := 114;
    btnFirst.Top := 115;
    btnFirst.Width := 100;
    btnFirst.Height := 40;
    btnFirst.Anchors := [akTop,akRight];
    btnFirst.Caption := 'Save';
    btnFirst.Color := clLightseagreen;
    btnFirst.Font.Charset := DEFAULT_CHARSET;
    btnFirst.Font.Color := clWindowText;
    btnFirst.Font.Height := -12;
    btnFirst.Font.Name := 'Segoe UI';
    btnFirst.Font.Style := [fsBold];
    btnFirst.HeightPercent := 100.000000000000000000;
    btnFirst.ParentFont := False;
    btnFirst.TabOrder := 0;
    btnFirst.WidthPercent := 100.000000000000000000;
    btnSecond.SetParentComponent(sbMain);
    btnSecond.Name := 'btnSecond';
    btnSecond.Left := 256;
    btnSecond.Top := 115;
    btnSecond.Width := 100;
    btnSecond.Height := 40;
    btnSecond.Anchors := [akTop,akRight];
    btnSecond.Caption := 'Cancel';
    btnSecond.Color := clGold;
    btnSecond.Font.Charset := DEFAULT_CHARSET;
    btnSecond.Font.Color := clWindowText;
    btnSecond.Font.Height := -12;
    btnSecond.Font.Name := 'Segoe UI';
    btnSecond.Font.Style := [fsBold];
    btnSecond.HeightPercent := 100.000000000000000000;
    btnSecond.ParentFont := False;
    btnSecond.TabOrder := 1;
    btnSecond.WidthPercent := 100.000000000000000000;
    SetEvent(btnSecond, Self, 'OnClick', 'btnSecondClick');
  finally
    lTitle.AfterLoadDFMValues;
    sbMain.AfterLoadDFMValues;
    lMessage.AfterLoadDFMValues;
    btnFirst.AfterLoadDFMValues;
    btnSecond.AfterLoadDFMValues;
  end;
end;

end.